module.exports = __webpack_public_path__ + "img/setcom.c2053604.jpg";